import { HttpHeaders } from '@angular/common/http';
import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  // Signal for reactive login state
  private _isUserLoggedIn = signal<boolean>(false);
  
  // Read-only signal for consumers
  readonly isUserLoggedIn = this._isUserLoggedIn.asReadonly();
  
  constructor() {
    // Initialize from localStorage on service creation
    this._isUserLoggedIn.set(localStorage.getItem('isUserLoggedIn') === 'true');
  }

  login(): void {
    localStorage.setItem('isUserLoggedIn', 'true');
    this._isUserLoggedIn.set(true);
  }

  logout(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('isUserLoggedIn');
    this._isUserLoggedIn.set(false);
  }
  getAuthHeaders(): HttpHeaders {
  const token = localStorage.getItem('access_token');
          return new HttpHeaders({
              'Authorization': `Bearer ${token}`
        });
  }
}
